import { connect } from "react-redux";

import { CandyDispatch } from "../../../Engine/Core/Store/CandyReduxTypes";
import { formCloseAction } from "../../../Engine/ActionCreators/FormActionCreators";

import { ModalHeader } from "./ModalHeader";

const mapDispatchToProps = (dispatch: CandyDispatch) => ({
    onCloseForm: () => dispatch(formCloseAction),
});

export const ModalHeaderContainer = connect(undefined, mapDispatchToProps)(ModalHeader);

ModalHeaderContainer.displayName = ModalHeader.name;
